import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { Button } from 'antd';
import { useWindowSize } from 'react-use';

const DownloadStoriesBottomContent = ({
  bottomInfo,
  inputIcon,
  placeholder,
  buttonTitle,
  loading,
  searchVal,
  inputVisible,
  onValueChanged,
  onSearchClick,
}: {
  bottomInfo?: {
    title?: string;
    desc?: string;
  };
  inputIcon?: React.ReactNode;
  placeholder?: string;
  buttonTitle?: string;
  loading?: boolean;
  searchVal?: string;
  inputVisible?: boolean;
  onValueChanged?: (e?: string) => void;
  onSearchClick?: (e?: string) => void;
}) => {
  const { t } = useTranslation('common');
  const [searchStr, setSearchStr] = useState(searchVal);
  const { width } = useWindowSize();

  useEffect(() => {
    if (searchVal !== searchStr) {
      setSearchStr(searchVal);
    }
  }, [searchVal]);

  const getInputItem = () => {
    return (
      <div className={styles.inputContainer}>
        {inputIcon ? (
          inputIcon
        ) : (
          <Image src={'/images/home/instagram-icon.webp'} alt="instagram" width={24} height={24} />
        )}

        <input
          disabled={loading}
          value={searchVal}
          onChange={(e) => {
            setSearchStr(e.target.value);
            onValueChanged && onValueChanged(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e?.key === 'Enter') {
              const value = (e.target as HTMLInputElement).value;
              onSearchClick && onSearchClick(value);
            }
          }}
          placeholder={placeholder ?? t('Enter profile link or username')}
        />
        <Button
          loading={loading}
          className={styles.searchBtn}
          disabled={loading}
          style={{
            cursor: 'pointer',
          }}
          onClick={() => {
            onSearchClick && onSearchClick(searchStr);
          }}
        >
          {buttonTitle ?? t('Search Now')}
        </Button>
      </div>
    );
  };

  const getContent = () => {
    return (
      <div className={styles.content}>
        <div className={styles.mainContent}>
          <div className={styles.title}>{bottomInfo?.title}</div>
          <p className={styles.desc}>{bottomInfo?.desc}</p>

          {getInputItem()}
        </div>
      </div>
    );
  };

  const bottomInfoContent = useMemo(() => {
    if (!bottomInfo) {
      return null;
    }
    return width > 768 ? getContent() : inputVisible ? null : getInputItem();
  }, [bottomInfo, width, loading, searchVal, inputVisible, searchStr]);

  return bottomInfoContent;
};

export default DownloadStoriesBottomContent;
